// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_is-0";
export var actionModalContentContainer = "_is-1";
export var createTagButton = "_is-2";
export var footerContainer = "_is-7";
export var fullWidthDivider = "_is-3";
export var hasCreateTagButton = "_is-4";
export var noCreateTagButton = "_is-5";
export var tagsContainer = "_is-6";
export var tagsModalContentContainer = "_is-8";